export default [
  // { type: 'Text', name: 'Texto' },
  // { type: 'Image', name: 'Imagem' },
  // { type: 'Video', name: 'Vídeo' },
  // { type: 'Audio', name: 'Áudio' },
  // { type: 'Document', name: 'Documento' },
  // { type: 'Menu', name: 'Menu' },
  // { type: 'Collect', name: 'Coleta' },
  // { type: 'Conditional', name: 'Condicional' },
  { type: 'API', name: 'JSON API' },
  { type: 'APIV2', name: 'API V2' },
  // { type: 'Form', name: 'Formulário' },
  // { type: 'SMS', name: 'SMS' },
  // { type: 'EMAIL', name: 'Email' },
  // { type: 'Script', name: 'Script' },
  // { type: 'Human', name: 'Humano' },
  // { type: 'DynamicMedia', name: 'Mídia dinâmica' },
  // { type: 'VTexAddToCart', name: '(VTex) Adicionar ao carrinho' },
  // { type: 'VTexUpdateCart', name: '(VTex) Atualizar carrinho' },
  // { type: 'VTexRemoveFromCart', name: '(VTex) Remover item do carrinho' },
  // { type: 'VTexCatalogProduct', name: '(VTex) Buscar produto do catalógo' },
  // { type: 'VTexCatalogProducts', name: '(VTex) Listar catálogo' },
  // { type: 'VTexCartProduct', name: '(VTex) Buscar produto do carrinho' },
  // { type: 'VTexOrderList', name: '(VTex) Listar carrinho' },
  // { type: 'VTexCheckout', name: '(VTex) Checkout' },
  // { type: 'ZendeskCreateRequest', name: '(Zendesk) Novo Ticket' },
  // { type: 'ZendeskListRequests', name: '(Zendesk) Listar Tickets' },
  // { type: 'ZendeskShowRequest', name: '(Zendesk) Mostrar Ticket' },
  // { type: 'ZendeskListComments', name: '(Zendesk) Listar Comentários' },
  // { type: 'ZendeskInsertComment', name: '(Zendesk) Inserir Comentário' },
  // { type: 'ZendeskAttachFile', name: '(Zendesk) Anexar Arquivo' },
  // { type: 'ZendeskUpdateStatusRequest', name: '(Zendesk) Finalizar Ticket' },
  // { type: 'JiraCreateIssue', name: '(Jira) Novo ticket' },
  // { type: 'JiraListIssues', name: '(Jira) Listar tickets' },
  // { type: 'JiraShowIssue', name: '(Jira) Checar ticket' },
  // { type: 'JiraListProjects', name: '(Jira) Listar projetos' },
  // { type: 'JiraListStatus', name: '(Jira) Listar Status' },
  // { type: 'JiraListRequestypes', name: '(Jira) Tipos ticket' },
  // { type: 'JiraListPriorities', name: '(Jira) Listar prioridades' },
  // { type: 'JiraListComments', name: '(Jira) Listar Comentários' },
  // { type: 'JiraInsertComment', name: '(Jira) Inserir Comentário' },
  // { type: 'JiraAttachFile', name: '(Jira) Anexar Arquivo' },
  // { type: 'JiraUpdateStatusIssue', name: '(Jira) Finalizar Ticket' },
  // { type: 'GlpiCreateRequest', name: '(GLPI) Novo Ticket' },
  // { type: 'GlpiListRequests', name: '(GLPI) Listar Tickets' },
  // { type: 'GlpiShowRequest', name: '(GLPI) Mostrar Ticket' },
  // { type: 'GlpiListComments', name: '(GLPI) Listar Comentários' },
  // { type: 'GlpiInsertComment', name: '(GLPI) Inserir Comentário' },
  // { type: 'GlpiAttachFile', name: '(GLPI) Anexar Arquivo' },
  // { type: 'GlpiUpdateStatusRequest', name: '(GLPI) Finalizar Ticket' },
  // { type: 'GlpiListGroups', name: '(GPLI) Listar Grupos' },
  // { type: 'Carousel', name: 'Carrossel' },
  // { type: 'VoiceTransferirRamalInternoExterno', name: '(Voice Bot) Ramal' },
  // { type: 'VoiceTTSAudio', name: '(Voice Bot) TTS Audio' },
  // { type: 'VoiceConfirmarVenda', name: '(Voice Bot) Venda' },
  // { type: 'VoiceTTSAudioASR', name: '(Voice Bot) ASR' },
  // { type: 'VoiceFinalizarAtendimento', name: '(Voice Bot) Finalizar' },
  // {
  //   type: 'VoiceTransferirRamalLocalizadorVendedor',
  //   name: '(Voice Bot) Vendedor',
  // },
  // { type: 'VoiceAgendarMailing', name: '(Voice Bot) Agendar' },
  // { type: 'VoiceTTSAudioDTMF', name: '(Voice Bot) DTMF' },
  // { type: 'VoiceWebservice', name: '(Voice Bot) Webservice' },
  // { type: 'VoiceSMS', name: '(Voice Bot) SMS' },
  // { type: 'Group', name: 'Grupo' },
  // { type: 'Redirect', name: 'Direcionador' },
  // { type: 'BotTransfer', name: 'Transferência de Bot' },
  // { type: 'MenuAI', name: 'Menu IA' },
];
